import clearEmployer from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer/actions/clearEmployer.js';
import initialize from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer/actions/initialize.js';
import setEmployer from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer/actions/setEmployer.js';
import updateErrors from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer/actions/updateErrors.js';

export default {
    clearEmployer,
    initialize,
    setEmployer,
    updateErrors,
};